import CTNDropdown from '@ctn/ui/components/ctn-dropdown';
import CTNField from '@ctn/ui/components/ctn-field';
import { CTNIcon } from '@ctn/ui/components/ctn-icon';
import CTNTableComponentRow from '@ctn/ui/components/ctn-table-component-row';

import { useEmpresa } from '@/context/empresa.context';

import { dropdownPriorityOptions } from '@/constants/empresa.constants';
import { type IListaTipoNotificacion, type INotificacionesTransformadas } from '@/interfaces/model/emisor.interface';
import type { ReactElement } from 'react';

import { columns } from './columns';

const ServiciosYNotificaciones = (): ReactElement => {
	const { emisor, isLoading, control, isEdit } = useEmpresa();
    
	const subComponent = (rowData: INotificacionesTransformadas): ReactElement => {
		const realIndex = emisor?.prioridadesNotificacion.findIndex(
			(p) => p.tipoTramite.id === rowData.id
		);

		if (realIndex === -1) return <></>;

		const renderPrioridad = (item: IListaTipoNotificacion): ReactElement | undefined => {
			const option = dropdownPriorityOptions.find((it) => it.value === item.prioridad.id);
			if (!option) return undefined;

			return (
				<div className='c-pnp-admin-priority__field-min'>
					<CTNIcon icon={option.icon ?? 'status'} color={option.iconColor} />
					<span>{option.label}</span>
				</div>
			);
		};

		return (
			<div className='c-pnp-admin-priority__wrapper'>
				{rowData.listaTipoNotificacionPrioridad.map((item, i) => (
					<div key={`${item.tipoNotificacion.id}`} className='c-pnp-admin-priority__container'>
						<CTNField
							label='Tipo de servicio y notificación' 
							className='c-pnp-admin-priority__field c-pnp-admin-priority__field--mobile'
						>
							<></>
						</CTNField>
						<div className='c-pnp-admin-priority__field'>{item.tipoNotificacion.descripcion}</div>
						<CTNField
							label='Prioridad notificaciones' 
							className='c-pnp-admin-priority__field c-pnp-admin-priority__field--mobile'
						>
							<></>
						</CTNField>
						{isEdit && (<CTNDropdown
							control={control}
							options={dropdownPriorityOptions}
							name={`emisor.prioridadesNotificacion.${realIndex}.listaTipoNotificacionPrioridad.${i}.prioridad.id`}
							classNameField='c-pnp-admin-priority__dropdown'
						/>)}
						{!isEdit && renderPrioridad(item)}
					</div>
				))}
			</div>
		);
	};

	const notificacionesTransformadas = (): INotificacionesTransformadas[] | undefined => 
		emisor?.prioridadesNotificacion?.map(item => ({
			id: item.tipoTramite.id,
			name: item.tipoTramite.descripcion,
			listaTipoNotificacionPrioridad: item.listaTipoNotificacionPrioridad
		}));

	return (
		<section className='c-pnp-admin-priority'>
			<div className='c-pnp-admin-priority__title'>Servicios disponibles y notificaciones</div>
			<CTNTableComponentRow
				visibleExpandableRows
				isExpandedByDefault={isEdit}
				loading={isLoading}
				columns={columns}
				data={notificacionesTransformadas() ?? []}
				idData="id"
				pageSize={10}
				renderSubComponent={(props: any) => {
					const rowData = props?.row?.original;
    
					return rowData 
						? subComponent(rowData) 
						: <></>;
				}}
				totalData={50}
			/>
		</section>
	);
};

export default ServiciosYNotificaciones;
